<template>
    <div class="w-full">
      <div class="w-full vs-con-loading__container" id="editarRelatorioOs">  
        <vs-row class="content-top-initial">
          <!-- Select para escolher a área -->
          <vs-col vs-w="2" class="widget-os-info">
            <p class="title-os">
              <i class="feather icon-clipboard"></i>
              Número da OS: 
              <span class="os-number">{{ osId }}</span>
            </p>
            <!-- Divisor horizontal -->
            <div class="divider"></div>
            <div class="totals">
              <span class="totals-item">Pragas: <strong>{{ totalPragas }}</strong></span>
              <span class="totals-item">Produtos: <strong>{{ totalProdutos }}</strong></span>
              <span class="totals-item">Recomendações: <strong>{{ totalRecomendacoes }}</strong></span>
            </div>
          </vs-col>
          <vs-col vs-w="3" class="select-areas">
            <p class="title-area">Selecione a Área</p>
            <el-select
              v-model="areaPragaSelecionada"
              :popper-append-to-body="false"
              placeholder="Selecionar Área"
              style="width: 100%;"
            >
              <el-option
                v-for="option in relatorioPorAreas"
                :key="option.id"
                :label="option.nome"
                :value="option.id"
              ></el-option>
            </el-select>
          </vs-col>    
        <!-- ROW CONTENT -->
        </vs-row>
        <vs-row class="content" vs-justify="space-evenly">  
          <vs-col vs-w="12">
            <div v-if="!areaPragaSelecionada" class="no-area-selected">
              <i class="alert-icon feather icon-alert-circle"></i>
              <p class="message">Selecione uma área para visualizar os dados.</p>
            </div>
          </vs-col>
          <vs-col vs-w="3">  
            <!-- Mostrar os dados apenas da área selecionada -->
            <vs-row
              v-if="areaPragaSelecionada && areaFiltradaPraga"
              vs-type="flex"
              class="mt-1 mb-4"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
             <!-- Itera sobre as pragas da área filtrada -->
            <vs-col vs-w="12">
              <div v-if="areaFiltradaPraga.pragas && areaFiltradaPraga.pragas.length > 0">    
                <div class="btn-add">
                  <h2 class="title-btn-add">Pragas</h2>
                  <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  class="btn"
                  type="flat"
                  size="large"
                  @click="adicionarPraga(areaFiltradaPraga.id)"
                  style="margin-left: 10px;"
                  >
                  </vs-button>
                </div>
                <div v-for="praga in areaFiltradaPraga.pragas" :key="praga.id" class="card">    
                <!-- Botão de excluir no canto superior direito -->
                <vs-button
                  icon-pack="feather"
                  icon="icon-x"
                  color="danger"
                  type="flat"
                  size="small"
                  style="position: absolute; top: 5px; right: 5px;"
                  @click="confirmarExclusaoPraga(praga.id, areaFiltradaPraga.id)"
                ></vs-button>
                  <vs-col vs-w="12">
                    <vs-row
                      class="content-praga-foto"
                      vs-w="12"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                    >
                      <vs-col vs-w="10">
                        <h4>{{ pragaNomeSelecionado(praga.id_praga) }}</h4>
  
                      </vs-col>
                      <vs-col vs-w="2">
                        <img :src="praga.foto" alt="Foto da Praga" class="small-img" />
                      </vs-col>
                    </vs-row>
                  </vs-col>    
                  <vs-row vs-w="12" class="mt-2">
                      <vs-col vs-w="12">
                      <p>Praga</p>
                      <el-select
                        v-model="praga.id_praga"
                        :popper-append-to-body="false"
                        placeholder="Selecionar Praga"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in pragasList"
                          :key="option.id"
                          :label="option.nome"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-w="12" class="mt-3" style="justify-content: space-between;">
                    <vs-col vs-w="5">
                      <p>Infestação</p>
                      <el-input
                        v-model="praga.infestacao"
                        type="text"
                        placeholder="Nível de Infestação"
                        style="width: 100%;"
                      ></el-input>
                    </vs-col>
  
                    <vs-col vs-w="6">
                      <p>Nível de Infestação</p>
                      <el-select
                        v-model="praga.id_nivel_infestacao"
                        :popper-append-to-body="false"
                        placeholder="Selecionar Nível de Infestação"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in niveisInfestacao"
                          :key="option.id"
                          :label="option.nome"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </vs-col>
  
                  </vs-row>
                </div>
              </div>
            </vs-col>
              <vs-col vs-w="12">
                <vs-button
                  @click="editarRelatorioOs"
                  color="success"
                  class="w-full mt-2"
                >
                  Salvar Pragas
                </vs-button>
              </vs-col>
            </vs-row>
          </vs-col>
        <!-- SESSÃO PRODUTOS -->
        <vs-col vs-w="3">
          <vs-row
            v-if="areaPragaSelecionada && areaFiltradaPraga"
            vs-type="flex"
            class="mt-1 mb-4"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <!-- Itera sobre as pragas da área -->
            <vs-col vs-w="12">
              <div v-if="areaFiltradaPraga.produtos && areaFiltradaPraga.produtos.length > 0">
                <div class="btn-add">
                  <h2 class="title-btn-add">Produtos</h2>
                  <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  class="btn"
                  type="flat"
                  size="large"
                  @click="adicionarProduto(areaFiltradaPraga.id)"
                  style="margin-left: 10px;"
                  >
                  </vs-button>
                </div>
                <div v-for="produto in areaFiltradaPraga.produtos" :key="produto.id" class="card">
                  <!-- Botão de excluir no canto superior direito -->
                  <vs-button
                    icon-pack="feather"
                    icon="icon-x"
                    color="danger"
                    type="flat"
                    size="small"
                    style="position: absolute; top: 5px; right: 5px;"
                    @click="confirmarExclusaoProduto(produto.id, areaFiltradaPraga.id)"
                  >
                  </vs-button>
                  <vs-row
                    vs-type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="12"
                  >
                    <vs-col vs-w="12">
                      <h4>{{ produtoNomeSelecionado(produto.id_produto) }}</h4>
                    </vs-col>
                  </vs-row>
                <vs-row vs-w="12" vs-type="flex" style="justify-content: space-between;">
                    <vs-col vs-w="12">
                      <p class="mt-2">Produto</p>
                      <el-select
                        v-model="produto.id_produto"
                        :popper-append-to-body="false"
                        placeholder="Selecionar produto"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in produtosList"
                          :key="option.id"
                          :label="option.nome"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </vs-col>
                    </vs-row>
                  <vs-row vs-w="12" vs-type="flex" class="mt-2" style="justify-content: space-between;">
                    <vs-col vs-w="4">
                      <p class="mt-2">Método</p>
                      <el-select
                        v-model="produto.id_metodo"
                        :popper-append-to-body="false"
                        placeholder="Selecionar Método"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in metodos"
                          :key="option.id"
                          :label="option.nome"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </vs-col>
                    <vs-col vs-w="3">
                      <p class="mt-2">Quantidade</p>
                      <el-input
                        v-model="produto.quantidade"
                        type="number"
                        placeholder="Quantidade"
                        style="width: 100%;"
                      />
                    </vs-col>
                    <vs-col vs-w="3">
                      <p class="mt-2">Lote</p>
                      <el-select
                        v-model="produto.id_produto_lote"
                        :popper-append-to-body="false"
                        placeholder="Selecionar Lote"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in lotes"
                          :key="option.id"
                          :label="option.lote"
                          :value="option.id"
                        ></el-option>
                      </el-select>
                    </vs-col>
                  </vs-row>
                </div>
              </div>
            </vs-col>
            <!-- Botão de Salvar Geral no final da coluna -->
            <vs-col vs-w="12">
              <vs-button
                @click="editarProduto"
                color="success"
                class="w-full mt-2"
              >
                Salvar Produtos
              </vs-button>
            </vs-col>
          </vs-row>
        </vs-col>
          <!-- SESSÃO RECOMENDAS -->
          <vs-col vs-w="3">
               <!-- Mostrar os dados apenas da área selecionada -->
               <vs-row
                  v-if="areaFiltradaPraga && areaFiltradaPraga"
                  vs-type="flex"
                  class="mt-1 mb-4"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="12"
                >
              <vs-col vs-w="12">
                <div v-if="areaFiltradaPraga.recomendacoes && areaFiltradaPraga.recomendacoes.length > 0">
                  <div class="btn-add">
                  <h2 class="title-btn-add">Recomendações</h2>
                  <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  class="btn"
                  type="flat"
                  size="large"
                  @click="adicionarRecomendacoes(areaFiltradaPraga.id)"
                  style="margin-left: 10px;"
                  >
                  </vs-button>
                </div>
                  <div v-for="recomendacao in areaFiltradaPraga.recomendacoes" :key="recomendacao.id" class="card">
                    <vs-button
                    icon-pack="feather"
                    icon="icon-x"
                    color="danger"
                    type="flat"
                    size="small"
                    style="position: absolute; top: 5px; right: 5px;"
                    @click="confirmarExclusaoRecomendas(recomendacao.id, areaFiltradaPraga.id)"
                  ></vs-button>
                    <vs-col
                      vs-w="12"
                      vs-type="flex"
                      vs-align="center"
                      vs-justify="center"
                    >
                      <div class="mt-10">
                        <el-upload
                          accept=".jpg, .jpeg, .png, .gif"
                          :key="reRender"
                          :on-remove="(file) => removerFotoOsRecomendas(recomendacao.id, areaFiltradaPraga.id)"
                          :action="linkMap[recomendacao.id] || ''" 
                          :auto-upload="true"
                          :on-error="erro"
                          :on-success="success"
                          class="w-full"
                          :limit="1"
                          :on-exceed="exceed"
                          :headers="headers"
                          :file-list="fileList[recomendacao.id] || []" 
                          name="image"
                          list-type="picture-card"
                          :on-preview="handlePreview"
                        >
                          <i class="el-icon-plus" style="font-size: 22px">Avatar</i>
                        </el-upload>
  
                        <el-dialog :visible.sync="dialogVisible">
                          <img width="100%" :src="dialogImageUrl" alt />
                        </el-dialog>
                      </div>
                    </vs-col>
                    <vs-col vs-w="12">
                      <p class="mt-2">Frase</p>
                      <el-select
                        v-model="recomendacao.id_frase"
                        :popper-append-to-body="false"
                        placeholder="Selecionar Frase"
                        style="width: 100%;"
                      >
                        <el-option
                          v-for="option in frases"
                          :key="option.id"
                          :label="option.frase"
                          :value="option.id"
                        />
                      </el-select>
                    </vs-col>
                    <vs-col vs-w="12">
                      <p class="mt-2">Texto</p>
                      <el-input
                        v-model="recomendacao.texto"
                        type="textarea"
                        placeholder="Digite o texto recomendado"
                        style="width: 100%;resize: none;"
                      />
                    </vs-col>
                  </div>
                </div>
              </vs-col>
              <vs-col vs-w="12">
                <vs-button
                  @click="editarRecomendacoes"
                  color="success"
                  class="w-full button"
                >
                  Salvar Recomendação
                </vs-button>
              </vs-col>
            </vs-row>  
          </vs-col>
        </vs-row>  
        <!-- END ROW CONTENT -->
      </div>
    </div>
  </template>
  
  
  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        linkMap: {},
        osId: this.$route.params.id,  
        clienteId: this.$route.query.cliente,
        contratoId: this.$route.query.contrato,
        areaPragaSelecionada: null,
        praga: null,
        produto: null,
        recomenda: null,
        popupTitle: '',
        pragas: [],
        produtos: [],
        recomendas: [],
        niveisInfestacao: [],
        responseNiveisteste: [],
        metodos: [],
        areas: [],
        lotes: [],
        frases: [],
        pragasList: [],
        produtosList: [],
        relatorioPorAreas: [],
        osSelecionado: {},
        reRender: 0,
        link: "#",
        error: false,
        fileList: [],
        dialogVisible: false,
        dialogImageUrl: "#",
        headers: {
          Authorization: "Bearer ".concat(localStorage.getItem("token")),
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Headers": "Content-Type, Authorization",
          "Access-Control-Allow-Origin": "*"
        },
        
      };
    },
      
    computed: {
      areaFiltradaPraga() {
        return this.relatorioPorAreas.find(area => area.id === this.areaPragaSelecionada);
      },
      totalPragas() {
        if (this.areaFiltradaPraga) {
          return this.areaFiltradaPraga.pragas ? this.areaFiltradaPraga.pragas.length : 0;
        }
        return 0;
      },
      totalProdutos() {
        if (this.areaFiltradaPraga) {
          return this.areaFiltradaPraga.produtos ? this.areaFiltradaPraga.produtos.length : 0;
        }
        return 0;
      },
      totalRecomendacoes() {
        if (this.areaFiltradaPraga) {
          return this.areaFiltradaPraga.recomendacoes ? this.areaFiltradaPraga.recomendacoes.length : 0;
        }
        return 0;
      }
    },
    watch: {
      relatorioPorAreas(val) {
        if (val && val.length > 0) {
          this.updateLink();
          this.mountFileList();
        }
      },
    },
    linkMap: {
      handler(newLinkMap) {
        if (newLinkMap[recomendacao.id]) {
        }
      },
      deep: true,
      },
  
    methods: {   
      confirmarExclusaoPraga(idPraga, idArea) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Excluir Praga',
          text: 'Tem certeza de que deseja excluir esta praga?',
          acceptText: 'Sim',
          cancelText: 'Não',
          accept: () => {
            this.deletarPraga(idPraga, idArea);
          }
        });
      },
  
      confirmarExclusaoProduto(idProduto, idArea) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Excluir Produto',
          text: 'Tem certeza de que deseja excluir este produto?',
          acceptText: 'Sim',
          cancelText: 'Não',
          accept: () => {
            this.deletarProduto(idProduto, idArea);
          }
        });
      },
  
      confirmarExclusaoRecomendas(idRecoendas, idArea) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Excluir Recomendações',
          text: 'Tem certeza de que deseja excluir esta recomendação?',
          acceptText: 'Sim',
          cancelText: 'Não',
          accept: () => {
            this.deletarRecomendacoes(idRecoendas, idArea);
          }
        });
      },
      pragaNomeSelecionado(id) {
        if (id) { 
          const praga = this.pragasList.find(option => option.id === id);
          return praga ? praga.nome : ''; 
        }
        return ''; 
      },
      produtoNomeSelecionado(id) {
        if (id) { 
          const produto = this.produtosList.find(option => option.id === id);
          return produto ? produto.nome : ''; 
        }
        return ''; 
      },
      async mountFileList() {
        this.fileList = {}; 
        for (const area of this.relatorioPorAreas) {  
          for (const recomenda of area.recomendacoes) { 
            if (recomenda.foto) { 
              this.$set(this.fileList, recomenda.id, [{
                name: `${recomenda.texto}`,
                url: `${recomenda.foto}`,
                uid: Date.now()
              }]);
            } else {
              this.$vs.notify(`Nenhuma foto encontrada para a recomendação: ${recomenda.texto}.`);
            }
          }
        }
      },
      updateLink() {
        if (this.relatorioPorAreas && this.relatorioPorAreas.length > 0) {
          this.relatorioPorAreas.forEach(area => {
            if (area.recomendacoes) {
              area.recomendacoes.forEach(recomenda => {
                this.$set(this.linkMap, recomenda.id, `${process.env.VUE_APP_URL}/avatar-recomendacoes/adicionar/${this.osId}/area/${area.id}/recomendacao/${recomenda.id}`);
              });
            }
          });
        }
      },
      async adicionarPraga() {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          const areaSelecionada = this.relatorioPorAreas.find(area => area.id === this.areaFiltradaPraga.id);
          if (!areaSelecionada) {
            throw new Error("Área não encontrada para a praga selecionada.");
          }
          const response = await axios.post(`${process.env.VUE_APP_URL}/relatorio-os-pragas/adicionar/${this.osId}/area/${areaSelecionada.id}`);
          if (response.status === 201) {
            const novoIdPraga = response.data.id; 
            const novaPraga = {
              id: novoIdPraga, 
              id_praga: null, 
              infestacao: '',
              id_nivel_infestacao: null, 
              id_area: areaSelecionada.id,   
            };
              areaSelecionada.pragas.push(novaPraga);
  
            this.$vs.notify({ title: 'Sucesso', text: 'Praga adicionada com sucesso!', color: 'success' });
          } else {
            throw new Error('Erro ao adicionar praga. Resposta do servidor não foi bem-sucedida.');
          }
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
        } finally {
          this.modalOs = false;
          await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
      async editarRelatorioOs() {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          for (const area of this.relatorioPorAreas) {
            for (const praga of area.pragas) {
              const urlPraga = `${process.env.VUE_APP_URL}/relatorio-os-pragas/editar/os/${this.osId}/praga/${praga.id}/area/${area.id}`;
              const pragaObj = {
                infestacao: praga.infestacao,
                id: praga.id, 
                id_praga: praga.id_praga,
                id_nivel_infestacao: praga.id_nivel_infestacao
              };
              const response = await axios.put(urlPraga, pragaObj);
              
              if (response.status !== 200) {
              throw new Error(`Erro ao atualizar praga com ID ${praga.id}`);
              }
            }
          }
            await this.$vs.notify({ title: 'Sucesso', text: 'Pragas e Áreas atualizadas com sucesso!', color: 'success' });
            await this.$emit("emitirUpdate");
        } catch (err) {
            const error = this.$httpErrors(err);
            await this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
          
            if (error.code === 401) {
              await window.localStorage.clear();
              await this.$router.push("/");
            }
        } finally {
          this.modalOs = false;
          await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
      async deletarPraga(idPraga) {
        try {
          const response = await axios.delete(`${process.env.VUE_APP_URL}/relatorio-os-pragas/excluir/${idPraga}`);
          if (response.status === 200) {
              this.relatorioPorAreas = this.relatorioPorAreas.map(area => {
              area.pragas = area.pragas.filter(praga => praga.id !== idPraga);
              return area;
              });
  
              this.$vs.notify({ title: 'Sucesso', text: 'Praga excluída com sucesso!', color: 'success' });
          } else {
            throw new Error('Erro ao excluir a praga');
          }
        } catch (err) {
            const error = this.$httpErrors(err);
            this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
            if (error.code === 401) {
            window.localStorage.clear();
            this.$router.push("/");
          }
        }
      },
      async adicionarProduto() {
          await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
          try {
            const areaSelecionada = this.relatorioPorAreas.find(area => area.id === this.areaFiltradaPraga.id);
            if (!areaSelecionada) {
              throw new Error("Área não encontrada para a praga selecionada.");
            }
            const url = `${process.env.VUE_APP_URL}/relatorio-os-produtos/adicionar/${this.osId}/area/${areaSelecionada.id}`;
            const response = await axios.post(url);
            if (response.status === 201) {
                const novoIdProduto = response.data.id; 
                const novoProduto = {
                  id: novoIdProduto, 
                  id_produto: null,
                  id_metodo: null,
                  quantidade: 0,
                  isca: 0,
                  id_produto_lote: null
                };
                areaSelecionada.produtos.push(novoProduto);
  
                this.$vs.notify({ title: 'Sucesso', text: 'Praga adicionada com sucesso!', color: 'success' });
            } else {
              throw new Error('Erro ao adicionar praga. Resposta do servidor não foi bem-sucedida.');
            }
          } catch (err) {
            const error = this.$httpErrors(err);
            this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
          } finally {
            this.modalOs = false;
            await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
          }
        },
  
      async editarProduto() {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          for (const area of this.relatorioPorAreas) {
            for (const produto of area.produtos) {
              const urlProduto = `${process.env.VUE_APP_URL}/relatorio-os-produtos/editar/os/${this.osId}/produto/${produto.id}/area/${area.id}`;
        
              const ProdutoObj = {
                id_area: produto.id_area,
                id_produto: produto.id_produto,
                id_metodo: produto.id_metodo,
                quantidade: produto.quantidade,
                isca: produto.isca,
                id_produto_lote: produto.id_produto_lote
              };
              const response = await axios.put(urlProduto, ProdutoObj);
  
              if(response.status !== 200) {
                throw new Error(`Erro ao atualizar produto com ID ${produto.id}`);
              }
            }
          }
          await this.$vs.notify({ title: 'Sucesso', text: 'Produtos atualizados com sucesso!', color: 'success' });
          await this.$emit("emitirUpdate");
  
        } catch (err) {
          const error = this.$httpErrors(err);
          await this.$vs.notify({ title: 'Erro', text: error.message, color: 'danger' });
          if (error.code === 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        } finally {
          await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
  
      async deletarProduto(idProduto) {
        const url = `${process.env.VUE_APP_URL}/relatorio-os-produtos/excluir/${idProduto}`; 
        try {
            const response = await axios.delete(url);
            if (response.status === 200) {
              this.relatorioPorAreas = this.relatorioPorAreas.map(area => {
                area.produtos = area.produtos.filter(produto => produto.id !== idProduto);
                return area;
              });
  
              this.$vs.notify({ title: 'Sucesso', text: 'Produto excluído com sucesso!', color: 'success' });
            } else {
              throw new Error('Erro ao excluir o produto');
            }
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
          if (error.code === 401) {
            window.localStorage.clear();
            this.$router.push("/");
          }
        }
      },
  
      async adicionarRecomendacoes() {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          const areaSelecionada = this.relatorioPorAreas.find(area => area.id === this.areaFiltradaPraga.id);
          if (!areaSelecionada) {
              throw new Error("Área não encontrada para a praga selecionada.");
          }
          const url = `${process.env.VUE_APP_URL}/relatorio-os-recomendacoes/adicionar/${this.osId}/area/${areaSelecionada.id}`;
          const response = await axios.post(url);
  
          if (response.status === 201) {
              const novoIdRecomendas = response.data.id;
              const novaRecomenda = {
                  id: novoIdRecomendas,
                  id_frase: null,
                  texto: '', 
                  id_area: areaSelecionada.id,
              };
              areaSelecionada.recomendacoes.push(novaRecomenda);
  
              this.$vs.notify({ title: 'Sucesso', text: 'Praga adicionada com sucesso!', color: 'success' });
          } else {
            throw new Error('Erro ao adicionar praga. Resposta do servidor não foi bem-sucedida.');
          }
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
        } finally {
          this.modalOs = false;
          await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
  
      async editarRecomendacoes() {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          for (const area of this.relatorioPorAreas) {
            for(const recomenda of area.recomendacoes) {
              const url = `${process.env.VUE_APP_URL}/relatorio-os-recomendacoes/editar/os/${this.osId}/recomenda/${recomenda.id}/area/${area.id}`;
          
            const obj = {
              id_area: recomenda.id_area, 
              id_frase: recomenda.id_frase,
              texto: recomenda.texto
            };
  
            const response = await axios.put(url, obj);
  
            if (response.status !== 200) {
              throw new Error(`Erro ao atualizar praga com ID ${recomenda.id}`);
            }
           }
          }
          await this.$vs.notify({ title: 'Sucesso', text: 'Recomendações atualizadas com sucesso!', color: 'success' });
          await this.$emit("emitirUpdate");
  
        } catch (err) {
          const error = this.$httpErrors(err);
          await this.$vs.notify({ title: 'Erro', text: error.message, color: 'danger' });
  
          if (error.code === 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        } finally {
          this.modalOs = false;
          await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
  
      async deletarRecomendacoes(idRecomendas) {
        const url = `${process.env.VUE_APP_URL}/relatorio-os-recomendacoes/excluir/${idRecomendas}`; 
        try {
          const response = await axios.delete(url);
          if (response.status === 200) {
            this.relatorioPorAreas = this.relatorioPorAreas.map(area => {
              area.recomendacoes = area.recomendacoes.filter(recomendas => recomendas.id !== idRecomendas);
              return area;
            });
            this.$vs.notify({ title: 'Sucesso', text: 'Produto excluído com sucesso!', color: 'success' });
          } else {
            throw new Error('Erro ao excluir o produto');
          }
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify({ title: 'Erro', text: error.message || 'Erro desconhecido.', color: 'danger' });
          if (error.code === 401) {
            window.localStorage.clear();
            this.$router.push("/");
          }
        }
      },
  
      async carregarDados() {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          const responseRelatorio = await axios.get(`${process.env.VUE_APP_URL}/getRelatorioOsEditar/${this.osId}`);
  
          this.relatorioPorAreas = responseRelatorio.data.areas || [];
          this.osSelecionado = responseRelatorio.data.os || {}; 
  
          this.recomendas = responseRelatorio.data.areas.flatMap(area => area.recomendacoes || []);
          this.produtos = responseRelatorio.data.areas.flatMap(area => area.produtos || []);
          this.pragas = responseRelatorio.data.areas.flatMap(area => area.pragas || []);
  
          this.niveisInfestacao = await this.$http.get("nivel_infestacao");
          this.metodos  = await this.$http.get("metodos");
          this.areas  = await this.$http.get("areas");
          this.lotes  = await this.$http.get("produtosLotes");
          this.frases  = await this.$http.get("frases");
          this.pragasList  = await this.$http.get("praga");
          this.produtosList  = await this.$http.get("produtos");
        } catch (err) {
          const error = this.$httpErrors(err);
          console.log("Erro ao carregar dados: ", err);
          console.log("ERRO httpErrors:  ", error);
          console.error("Erro ao carregar dados: ", err);
          console.error("ERRO httpErrors:  ", error);
          this.$vs.notify(error);
          if (error.code === 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        } finally {
          await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
      async removerFotoOsRecomendas(idFoto) {
        await this.$vs.loading({ container: "#editarRelatorioOs", scale: 0.6 });
        try {
          const deleteUrl = `${process.env.VUE_APP_URL}/avatar-recomendacoes/excluir/${idFoto}`;
          const response = await axios.delete(deleteUrl);
          if (response.status === 200) {
            this.recomendas.foto = null;
            await this.mountFileList();
            this.$vs.notify({
                title: 'Sucesso',
                text: 'Foto excluída com sucesso!',
                color: 'success'
              });
            } else {
              throw new Error(`Erro ao excluir foto para recomendação com ID ${idFoto}`);
            }
  
        } catch (err) {
          const error = this.$httpErrors(err);    
          this.$vs.notify({
            title: 'Erro',
            text: error.message || 'Erro desconhecido.',
            color: 'danger'
          });
          if (error.code === 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        } finally {
            await this.$vs.loading.close("#editarRelatorioOs > .con-vs-loading");
        }
      },
      async success() {
        this.$vs.notify({
          title: "Sucesso",
          text: "Avatar Salvo com Sucesso!",
          color: "success"
        });
        await this.$emit("update");
      },
      async erro() {
        this.$vs.notify({
          title: "Ocorreu um erro",
          text: "Avatar não foi salvo! Tente novamente mais tarde!",
          color: "danger"
        });
        await this.$emit("update");
      },
      async exceed() {
        this.$vs.notify({
          title: "Tenha Calma!",
          text: "Somente 1 Imagem para o Avatar!",
          color: "danger"
        });
      },
      async handlePreview(file) {
        this.dialogImageUrl = await file.url;
        this.dialogVisible = await true;
      },
  
    },
  
    mounted() {
      this.mountFileList()
      this.updateLink();
      this.carregarDados(); 
      if (this.relatorioPorAreas.length > 0) {
        this.areaPragaSelecionada = this.relatorioPorAreas[0].id;
      }
    }
  }
  </script>
  
  <style scoped>
  
  .totals {
    font-size: 14px;
    color: #555;
  }
  
  .title-os {
    font-size: 20px;
    color: #1c1c1c;
  }
  
  .os {
    font-weight: bold;
  }
  .title-area {
    font-size: 20px;
    color: #1c1c1c;
  }
  .btn-add { 
    padding: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #1c1c1c;
    background-color: #00BBA2; 
    /* #ffca00 */
    border-radius: 5px;
  }
  .title-btn-add { 
    font-size: 20px;                    
    font-weight: 600;               
    text-transform: capitalize;
    letter-spacing: 1px;                   
    line-height: 1.5;         
    color: #FFF;             
  
  }
  .btn {
    font-size: 2em;
    font-weight: bold;
    color: #fff;
  }
  h4 {
    text-transform: uppercase;
  }
    .content-top-initial {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-evenly;
      background-color: #f8f8f8;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      text-align: left;
      padding-top: 35px;
      padding-bottom: 25px;
      margin-top: -2em;
      margin-bottom: 2.5em;
  
  }
    .content {
      display: flex;
      justify-content: space-between;
    }
    .small-img {
      width: 150px; 
      height: auto; 
      object-fit: cover;
      order: 1px solid #333;
      box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
    }
    .img-recomendas {
      max-width: 200px; width: 150px; 
      height: auto; 
      object-fit: cover;
      order: 1px solid #333;
      box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
      margin-top: 20px;
    }
  
    .content-area {
      margin-top: 10px;
    }
    .el-select, .el-input {
    border-radius: 5px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s ease;
  }
  
  .el-select:hover {
    border-color: #2980b9;
  }
  
  .el-select .el-input__inner {
    padding: 10px 15px;
    font-size: 0.875rem;
    border-radius: 5px;
    background-color: #ecf0f1;
  }
  .content-praga-foto {
    margin-top: 1em;
  }
  .card {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 1em;
    padding: 20px;
  }
  
  .no-area-selected {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: #f8f8f8;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .alert-icon {
    margin-bottom: 20px;
    color: #00BBA2;
    font-size: 4em;
  }
  
  .message {
    font-size: 30px;
    color: #555;
    font-weight: 500;
    margin-top: 10px;
  }
  
  .no-area-selected:hover {
    background-color: #f0f0f0;
    border-color: #d1d1d1;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }
  .widget-os-info {
    background: #f5f5f5;
    border: 1px solid #ddd; 
    border-radius: 8px;
    padding: 16px; 
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
    text-align: center; 
    transition: transform 0.3s ease; 
  }
  
  .widget-os-info:hover {
    transform: scale(1.03); 
  }
  
  .title-os {
    font-size: 1.1em;
    color: #333; 
    margin-bottom: 12px; 
    font-weight: bold; 
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .os-number {
    color: #00BBA2; 
    font-weight: bold;
    margin-left: 8px;
  }
  
  .divider {
    border-bottom: 1px solid #ddd;
    margin: 12px 0;
  }
  
  .totals {
    display: flex;
    flex-direction: column;
    gap: 8px; 
  }
  
  .totals-item {
    color: #555; 
    font-size: 0.95em;
  }
  
  .totals-item strong {
    color: #00BBA2;
  }
  
  
  
  
  
  </style>